module.exports = __webpack_public_path__ + "img/add_col_before.ae95c360.svg";